import { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import axios from 'axios';

import { Copy, FilePlus, TimeClock, Search, UnfoldMore, MarkerPin, MoreVertical, ChevronUp, File, Comment, ChevronDown, ChevronDown2, ChevronDown3, ChevronUp2, ChevronUp3, Minus2, Hashtag, Filter, Edit, FormatScaleVertical, FileEdit } from "../../files/icons/index.js";

import { EditableDatePicker } from '../components/datePicker.js';
import MaskedInput from "../components/maskedInput.js";

import { AppContext } from '../../context.js';

import { Button } from '../components/component.js';

function Form() {
  const context = useContext(AppContext);

  let { id } = useParams();
  
  let formID = id;

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  const [template, setTemplate] = useState(null);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [form, setForm] = useState({});

  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.get('/api/public/referrals/' + formID, {
        
      }),
    ]).then(axios.spread((form) => {
      setTemplate(form.data.template);

      // Initialize form with default values
      const newForm = {};
      //newForm["dateOfBirth"] = new Date(0);
      setForm(newForm);

      // setPatient(users.data[0]);
      // setCustomFields(fields.data);

      // setProfile(profile.data);
      // setProjects(projects.data.projects);
      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  function renderPages() {
    return template.pages.map((page) => {
      return (
        <div key={page.id} className="card mb-2">
          <div className="card-header sm">
            <div className="typo-strong-175">{page.title}</div>
          </div>
          <div className="card-content sm">
            {page.lines.map((line, index) => renderLine(page.id, line, page.lines.length === index + 1))}
          </div>
        </div>
      );
    });
  }

  function renderLine(pageID, line, isLastLine) {
    // Line example
    //[{"code": "firstName", "size": 6}, {"code": "lastName", "size": 6}]

    return (
      <div key={"page_"+pageID+"_line_"+line.id} className={"row " + (isLastLine ? "" : "mb-2")}>
        {line.map((lineField, index) => {
          let field = template.fields.find((f) => f.code === lineField.code);

          return (
            <div key={"page_"+pageID+"_line_"+line.id+"_field_"+field.code} className={`col-xs-${lineField.size} py-0`}>
              <div className="typo-strong-150">{field.title}:</div>

              {field.type === "text" && !field.format && (
                <input type="text" placeholder="" value={form[field.code]} onChange={(e) => changeField(field.code, e.target.value)} className="input sm typo-normal-150 w-100" />
              )}

              {field.type === "text" && field.format && (
                <MaskedInput
                  value={form[field.code]}
                  onChange={(value) => changeField(field.code, value)}
                  formatRegex={field.format}
                  className="input sm typo-normal-150 w-100"
                />
              )}

              {field.type === "date" && (
                <EditableDatePicker 
                  date={form[field.code]}
                  onChange={(e) => changeField(field.code, e)}
                  rightIcon={<ChevronDown height={16} width={16} color={'grey'} />}
                  defaultLevel="year"
                />
              )}

              {field.type === "radio" && (
                field.options.map((option) => {
                  return (
                    <div key={"radio_"+field.code+"_"+option} className={"item typo-normal-150 me-2 " + (form[field.code] == option ? "blue" : "grey")} onClick={(e) => changeField(field.code, option)}>{option}</div>
                  );
                })
              )}

              {/* {field.type === "text" && (
                <input type="text" className="input sm typo-normal-150 w-100" placeholder="" style={{backgroundColor: "#eee"}} value={form[field.code]} onChange={(e) => changeField(field.code, e.target.value)} />
              )}

              {field.type === "radio" && (
                field.options.map((option) => {
                  return (
                    <div key={"radio_"+field.code+"_"+option} className={"item typo-normal-150 me-2 " + (form[field.code] == option ? "blue" : "grey")} onClick={(e) => changeField(field.code, option)}>{option}</div>
                  );
                })
              )} */}
            </div>
          );
        })}
      </div>
    );
  }

  function changeField(name, value) {
    // Create a new object to avoid direct mutation
    const newForm = { ...form, [name]: value ? value : null };
    setForm(newForm);
  }

  function send() {
    form["firstName"] = firstName;
    form["lastName"] = lastName;
    form["email"] = email;
    form["phone"] = phone;
    form["message"] = message;

    let u = context.addSpiner();
    axios.post('/api/public/forms/'+template.id, {
      values: form,
    }).then((response) => {
      setSending(true);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  if (sending) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-lg-8 col-lg-offset-2">

            <div style={{paddingTop: "20%"}} />
            
            <div className="d-flex justify-content-center align-items-center">
              <img src={"/api/public/logo"} style={{height: 50}} />
            </div>
            <div className="d-flex justify-content-center align-items-center mt-3">
              <span className="typo-strong-175">Form sent successfully!</span>
            </div>
             
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <></>
    );
  } 

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8 col-lg-offset-2">

          <div style={{paddingTop: "20%"}} />

          <img src={"/api/public/logo"} style={{height: 50, marginBottom: 10}} />

          <div className="card mb-2">
            <div className="card-header sm">
              <div className="typo-strong-175">
                Required Fields
              </div>
            </div>
            <div className="card-content sm">

              <div className="row mb-2">
                <div className="col-xs-4">
                  <div className="typo-strong-150">First Name:</div>
                  <input type="text" placeholder="" className="input sm typo-normal-150 w-100" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </div>
                <div className="col-xs-4">
                  <div className="typo-strong-150">Last Name:</div>
                  <input type="text" placeholder="" className="input sm typo-normal-150 w-100" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </div>
              </div>

              <div className="row">
                <div className="col-xs-4">
                  <div className="typo-strong-150">Email Address:</div>
                  <input type="text" placeholder="" className="input sm typo-normal-150 w-100" value={email} onChange={(e) => setEmail(e.target.value)} />
                  <div className="typo-strong-150 mt-2">Phone Number:</div>
                  <input type="text" placeholder="" className="input sm typo-normal-150 w-100" value={phone} onChange={(e) => setPhone(e.target.value)} />
                </div>
                <div className="col-xs-8">
                  <div className="typo-strong-150">Message:</div>
                  <textarea rows="4" placeholder="" className="input sm typo-normal-150 w-100" value={message} onChange={(e) => setMessage(e.target.value)} />
                </div>
              </div>
            </div>
          </div>

          {renderPages()}

          <div className="d-flex justify-content-end">
            <Button onClick={send} color="blue" text={"Send"} />
          </div>

        </div>
      </div>
    </div>
  );
}

export default Form;
